module.exports = __webpack_public_path__ + "static/media/Prabal_Gupta.f8fa36d7.jpg";